// extracted by mini-css-extract-plugin
module.exports = {"table":"bannerTable_table__nulFg","tableRow":"bannerTable_tableRow__PNky4"};